import { useQuery } from '@tanstack/react-query'

import { getProductSellersApiV1ProductsOrgIdSellersGet } from '@/common/api/client/sdk.gen'
import type { PageProductSellerSchema, ProductSellerSchema } from '@/common/api/client/types.gen'

export type ProductSeller = ProductSellerSchema

export const PRODUCT_SELLERS_QUERY_KEY = 'product-sellers'

const SELLERS_PAGE_SIZE = 100

const getSellers = async (org_id: string, q?: string): Promise<PageProductSellerSchema> => {
    const res = await getProductSellersApiV1ProductsOrgIdSellersGet({
        path: { org_id },
        query: {
            size: SELLERS_PAGE_SIZE,
            order_by: 'name',
            direction: 'asc',
            ...(q ? { q } : {}),
        },
    })
    return res.data!
}

export const useSellers = (orgId: string | undefined, q?: string) =>
    useQuery({
        queryKey: [PRODUCT_SELLERS_QUERY_KEY, orgId, q ?? ''],
        queryFn: () => getSellers(orgId as string, q),
        enabled: !!orgId,
    })
